import { createElement as rc } from 'react';
import { CheckBox, ScrollView, Text, View, styled } from 'lib_ui-primitives';
import FormListSelection, { _private } from './FormListSelection';
import useMultiSelect from '../../hooks/useMultiSelect';
import useCardBody from '../list/CardList/useCardBody';

const Cards = styled(ScrollView)`
    flex: 1;
    min-width: 0;
    min-height: 0;
`;

const Row = styled(View)`
    flex-direction: row;
    align-items: flex-start;
    flex-shrink: 0;
    padding: 8px 4px;
    gap: 8px;
`;

const Content = styled(View)`
    flex: 1;
    min-width: 0;
`;

/** Display form-owned records with the same columns and selection as a form list. */
export default function FormCardList(props) {
    const { value, disabled } = _private.useFormControl(props);
    const records = Array.isArray(value) ? value : [];
    const listProps = { ...props, records, rows: records, disabled };
    return props.hNode.selectionProperty
        ? rc(FormListSelection, listProps, rc(FormCards, listProps))
        : rc(FormCards, listProps);
}

function FormCards(props) {
    const { hNode, records, disabled } = props;
    const { isSelected, onIndividualChange, onChangeEverything, invertSelection } = useMultiSelect(hNode);
    const CardBody = useCardBody(hNode, { autoHeight: true });
    // prettier-ignore
    return rc(Cards, { id: hNode.id },
        hNode.selectionProperty && records.length > 0 && rc(Row, null,
            rc(CheckBox, { id: `${hNode.id}-all`, value: invertSelection, disabled, onClick: onChangeEverything }),
            rc(Text, null, 'Select all')
        ),
        records.map(item => rc(Row, { key: item._id },
            hNode.selectionProperty && rc(CheckBox, {
                id: `${hNode.id}-${item._id}`, value: isSelected(item._id), disabled,
                onClick: value => onIndividualChange(item._id, value)
            }),
            rc(Content, null, rc(CardBody, { item }))
        ))
    );
}
